module.exports = __webpack_public_path__ + "fonts/fa-regular-400.73fe7f1.ttf";